import SignUp from 'routes/client/routes/SignUp'

export default SignUp
